var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videointerview"},[_c('div',{staticClass:"menu"},_vm._l((_vm.menu),function(item){return _c('router-link',{key:item.name,staticClass:"item",attrs:{"exact":"","to":item.to}},[_vm._v(_vm._s(_vm.$tr(item.name)))])}),1),_vm._v(" "),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }